import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactsModule } from './contacts/contacts.module'
import { ViewsRoutingModule } from './views-routing.module';
import { LayoutModule } from '../common/layout/layout.module';
import { SharedModule } from '../common/shared/shared.module';
import { AuthModule } from './auth/auth.module';
import { ProfileModule } from './profile/profile.module';
import { CreateMessageModule } from './create-message/create-message.module';
import { MyDocumentsModule } from './my-documents/my-documents.module';

@NgModule({
    imports: [
        CommonModule,
        ViewsRoutingModule,
        LayoutModule,
        SharedModule,
        AuthModule,
        ProfileModule,
        CreateMessageModule,
        MyDocumentsModule,
        ContactsModule,
    ],
    declarations: [],
    exports: []
})
export class ViewsModule {
}
